import axios from 'axios'
import { KJUR, hextob64, KEYUTIL } from 'jsrsasign'

const API_BASE_URL = 'http://s.zgzgmall.cn/open_api/index.php/'
const API_USERNAME = 'api_live_9c14f264-e390-41df-984d-df15a6952031'
const API_PRIVATE_KEY = `MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAJvR8cMe8R2vLM/wZnYVOoaQW/Yb91FtME/RgRGhBksAIat6E5gnxSwzo3o1qVt0aKQvASwTQswlJVs9Ne4yUKBuz+FzeyZhr4i6hWe4uCsMyRU5ClcX3lxvYbAcb5CS8xLseoMw0kLG+ixy0v5r1PPpQYZyZw949e2rQ39DfiGlAgMBAAECgYBZH7slfJQzA1ghU4J3der0vqsq2JIcK9TfQpiNacm8qkWX3ApLFCxN/Pc7VmgY3Dth9VS5Tgb91x1H03n+VR8RzewO5pIpmD6ZIdnGEW87oWOaSe6tRyIQrlZmM8eeDyVDG0rhoqZFQTtLO8pSiocPeAo7HAonYKNf161tGbmBoQJBAORBd/ggsF4iAQqM3/bLIfPLQaOOab/LGy6IvaYs+COR/TzjHmdUu+Zj77l5n0czGZtYivwV/7M88wRYNQHRnu0CQQCuwodEc47Sgna9lttXUuOEnUnPkX/wOZwtWxWeVFbeHaEHdyASp4IBJwtqSccip4jq7wS4ktwp/JY9MPxPw/6ZAkAx1vHBJjIce8RKb3Q/yR8CwrD0a5Y/oLOwt37hmBQegDQRZW4wFdppdgzULPBQdaHzv6OpY4xPsNFHc5MvcHwJAkEAjlQyFIbE2B+XE1uMsjb4w6XSWnHWr9BLqQjYt4Va5jVdU5YqkebI06V3/42s2EV4FlaqEqTRGIT120pNA63NaQJAV13zcXu0daw2b0/lf05yOR/MzFd71VrHJYPXQq/BLggbkB8HL6GuhnHAj0tPCbrlvNxEiO6eq3JWick1UKeBIw==`

// 私钥格式化函数
const formatPrivateKey = (key) => {
    // 移除所有空格和换行符
    let cleaned = key.replace(/\s/g, ''); 
    const lines = [];
    for (let i = 0; i < cleaned.length; i += 64) {
      lines.push(cleaned.substr(i, 64));
    }
    cleaned = lines.join('\n');
    return `-----BEGIN PRIVATE KEY-----\n${cleaned}\n-----END PRIVATE KEY-----`;
}

// 签名生成函数
const generateSignature = (data) => {
  try {
    const pemKey = formatPrivateKey(API_PRIVATE_KEY);
    // console.log('格式化后的 PEM 私钥:', pemKey);
    const key = KEYUTIL.getKey(pemKey);
    const sig = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
    // console.log(sig,"sig");
    // console.log(JSON.stringify(data),"JSON.stringify(data)");
    
    sig.init(key); 
    sig.updateString(JSON.stringify(data));
    return hextob64(sig.sign());
  } catch (error) {
    console.error('签名生成失败:', error);
    throw new Error('签名生成失败');
  }
}

// 封装GET请求
export const httpGet = async (url, params = {}) => {
  try {
    const headers = {
      Authorization: API_USERNAME,
      'Content-Type': 'application/json'
    }

    // 添加签名
    headers.Signature = generateSignature(params)

    const response = await axios.get(`${API_BASE_URL}${url}`, {
      params,
      headers
    })

    return response.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

// 封装POST请求
export const httpPost = async (url, data = {}) => {
  try {
    const headers = {
      Authorization: API_USERNAME,
      'Content-Type': 'application/json'
    }
    
    // 添加签名
    headers.Signature = generateSignature(data)

    const response = await axios.post(`${API_BASE_URL}${url}`, data, {
      headers
    })

    return response.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

// 错误处理
const handleError = (error) => {
  if (error.response) {
    console.error(`[${error.response.status}] ${error.config.url}`)
    console.error('Response Data:', error.response.data)
  } else {
    console.error('Request Failed:', error.message)
  }
}